import { AssessmentOutcomeRefKey } from '@csp/csp-common-assessment';
import { isDefined } from '@csp/csp-common-util';
import { MasimoSpO2ConfigV1, MirPefConfigV1, ElaasFormulaCode, ElaasFormulaConfig } from '@csp/csp-common-rpm-model';
import { RefV1 } from '@csp/dmdp-api-device-dto';
import { MasimoSpO2AlgorithmInput, MirPefAlgorithmInput } from '../model/RpmEventAlgorithmInput';
import {
  MasimoSpO2AlgorithmResult,
  MirPefAlgorithmResult,
  RpmEventAlgorithmResult,
  RpmEventAlgorithmResultType,
} from '../model/RpmEventAlgorithmResult';

export type MaybeRefV1 = Omit<RefV1, 'value'> & {
  value?: string;
};

const filterOutUndefinedRefs = (refs: MaybeRefV1[]): RefV1[] =>
  refs.filter((ref): ref is RefV1 => isDefined(ref.value));

const toDeviceObservationAssessmentRefs = (id: string | undefined): RefV1[] =>
  filterOutUndefinedRefs([{ key: AssessmentOutcomeRefKey.DEVICE_OBSERVATION_ID, value: id }]);

const toMirPefAssessmentRefs = ({ currentObservation }: MirPefAlgorithmInput): RefV1[] =>
  toDeviceObservationAssessmentRefs(currentObservation.id);

const toMasimoSpO2AssessmentRefs = ({ currentObservation }: MasimoSpO2AlgorithmInput): RefV1[] =>
  toDeviceObservationAssessmentRefs(currentObservation.id);

const toAssessmentRefs = (
  algorithmResult: RpmEventAlgorithmResult<ElaasFormulaConfig, RpmEventAlgorithmResultType>,
): RefV1[] | undefined => {
  const { algorithmCode } = algorithmResult;
  switch (algorithmCode) {
    case ElaasFormulaCode.MIR_PEF: {
      const { result } = algorithmResult as RpmEventAlgorithmResult<MirPefConfigV1, MirPefAlgorithmResult>;

      return toMirPefAssessmentRefs(result.input);
    }
    case ElaasFormulaCode.MASIMO_SPO2: {
      const { result } = algorithmResult as RpmEventAlgorithmResult<MasimoSpO2ConfigV1, MasimoSpO2AlgorithmResult>;

      return toMasimoSpO2AssessmentRefs(result.input);
    }
  }

  return undefined;
};

export const AssessmentRefUtil = {
  filterOutUndefinedRefs,
  toAssessmentRefs,
};
